
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexqnu_45AxWuCFAtIzfzfF5SPDSS2w5_45wgUaN4Ttr5_huYYMeta } from "/home/circleci/sleuth/frontend/pages/index.vue?macro=true";
import { default as sign_45inRcFtNr8XsEZ7RHiDNTHDzFmQ3_45jzm_45dU8sd4Rjv_45xFEMeta } from "/home/circleci/sleuth/frontend/pages/sign-in.vue?macro=true";
import { default as sign_45upmCeQhReUuBLYjSuVke2gz_45B49cDVdnRjoh3pRYvCfyYMeta } from "/home/circleci/sleuth/frontend/pages/sign-up.vue?macro=true";
import { default as indexQURso_ymEAeAlcnfs_w0eiYx3kG_1EVWPzew5KVjjPYMeta } from "/home/circleci/sleuth/frontend/pages/home/index.vue?macro=true";
import { default as indexRt48hiOf_45TdEhcVnT0_0eeNXJuTsBkmRca6Llzu_45is0Meta } from "/home/circleci/sleuth/frontend/pages/roles/index.vue?macro=true";
import { default as indexSXrQ7uimFmQg8za_P2eyc93iyh2HlbFKdCo5jqo0hOkMeta } from "/home/circleci/sleuth/frontend/pages/usage/index.vue?macro=true";
import { default as _91gid_93ziWi_yW9phzitRuo8gVc4ohz9ZrYwTI98NAGfxg2lWQMeta } from "/home/circleci/sleuth/frontend/pages/assets/[gid].vue?macro=true";
import { default as indexspbO_459CERgyPM5xoX5d30hUyUchuMRhsTV5RXj_45NVn0Meta } from "/home/circleci/sleuth/frontend/pages/assets/index.vue?macro=true";
import { default as deviceXglsd_45yLRzveziYv_qa7hwevJuMp0BjB5S6HcbbXc5gMeta } from "/home/circleci/sleuth/frontend/pages/oauth/device.vue?macro=true";
import { default as tokensMaF9H66gvdbDF3bA_45_45qcaCuQw0eC0qNxADO1_BytTToMeta } from "/home/circleci/sleuth/frontend/pages/settings/user/tokens.vue?macro=true";
import { default as general14C8FQQxfk06kuXkVWHzmlkuDTK0RjYR6xehPLERJ6IMeta } from "/home/circleci/sleuth/frontend/pages/settings/user/general.vue?macro=true";
import { default as indexdgTu54HCKb06eqFlwLZpJEFOPfBGb_45H_m8_gPjKC8FQMeta } from "/home/circleci/sleuth/frontend/pages/settings/user/my/index.vue?macro=true";
import { default as externalhRqqKSQe6_45XO2LhltMb7L6wbcPcu85adK6KsvIM_TvEMeta } from "/home/circleci/sleuth/frontend/pages/settings/user/my/external.vue?macro=true";
import { default as notificationYtmshKaFnYIH0orIUeF6w3M0ycHwmH_og8EgOIFqiUsMeta } from "/home/circleci/sleuth/frontend/pages/settings/user/notification.vue?macro=true";
import { default as tokens_46generatedu0tADIHyC_45gkcZM0eqJkkDofXcHXCvUN9vpTEIbrAywMeta } from "/home/circleci/sleuth/frontend/pages/settings/user/tokens.generated.ts?macro=true";
import { default as index_46generatedE3a31sYcl_fXg5_45rKrUT3G5hPmUnDidWitQOC60OHJAMeta } from "/home/circleci/sleuth/frontend/pages/settings/user/my/index.generated.ts?macro=true";
import { default as notification_46generatedKcMjD_xPYP7xk58v7tdFvxF_45L1Eqruc48ce5nb0g3mgMeta } from "/home/circleci/sleuth/frontend/pages/settings/user/notification.generated.ts?macro=true";
import { default as userQDvU83MyYNp1yImAHSKfK6drtw0um2xaevjPIQnw9AoMeta } from "/home/circleci/sleuth/frontend/pages/settings/user.vue?macro=true";
import { default as nameboW9DqxLGcC_WwRJSzg7huzNRlBwUVZKjCWxMyffmhkMeta } from "/home/circleci/sleuth/frontend/pages/teamspace/new/name.vue?macro=true";
import { default as name_46generatedPvLan7SwhQ7JgbFSDZWUohM4D8gVggQcS_seV9ZtrSoMeta } from "/home/circleci/sleuth/frontend/pages/teamspace/new/name.generated.ts?macro=true";
import { default as teams_45and_45membersP9LtzR2f1_Dchz3tnGGNnKMWwB4QgRYqGsC6_c45BW4Meta } from "/home/circleci/sleuth/frontend/pages/teamspace/new/teams-and-members.vue?macro=true";
import { default as newVSLyjEauHwssktRMpnhNmWVJKIRlEl0uWSUGbh62LlwMeta } from "/home/circleci/sleuth/frontend/pages/teamspace/new.vue?macro=true";
import { default as _91botSlug_93PdRzHhM3P4kFScIfxFUNeJxtGzClM2lLvqFA1SkkhIkMeta } from "/home/circleci/sleuth/frontend/pages/bots/[botSlug].vue?macro=true";
import { default as delete_45accountWwrf_45Be7ZnkqB1PsLq12odCuLiXb2t4I_CE46AEOtUsMeta } from "/home/circleci/sleuth/frontend/pages/delete-account.vue?macro=true";
import { default as index_46generatedlkq_gFFRLe9cD78ze4vldWn61rbBqDbiURPlKORcUTIMeta } from "/home/circleci/sleuth/frontend/pages/index.generated.ts?macro=true";
import { default as indexIl5S6nTOBc6aEseblbrZ5qa75T13fkfdPoDj7o12Lc0Meta } from "/home/circleci/sleuth/frontend/pages/teams/[teamId]/index.vue?macro=true";
import { default as index_46generatedlwJhxhle7pvV_aq8AJgcwydMPKyOytSU8X9gmErIl_45kMeta } from "/home/circleci/sleuth/frontend/pages/teams/[teamId]/index.generated.ts?macro=true";
import { default as _91teamId_93CwfZxYJ45N7a9FbTCFmlcgpeSV9Th2pmbXCvlmnCbL0Meta } from "/home/circleci/sleuth/frontend/pages/teams/[teamId].vue?macro=true";
import { default as audit_45logVt8A3fgSlcz6ejzkpN8JViG5ESWln2rIlz7d2EapQv0Meta } from "/home/circleci/sleuth/frontend/pages/usage/audit-log.vue?macro=true";
import { default as indexLeTyFEGuQ2LXlcTz7ikNv9PsOl9WYUdmmkoyM8pnT1gMeta } from "/home/circleci/sleuth/frontend/pages/onboarding-wizard/index.vue?macro=true";
import { default as donerISYg3y4RUjVuZsgxJGsObcObDcSn5oijOtyQgABTYEMeta } from "/home/circleci/sleuth/frontend/pages/onboarding-wizard/org/done.vue?macro=true";
import { default as cliw3MEoU0QgFzEKFf0sOLduknfPySZVtEuJiGFBB149oQMeta } from "/home/circleci/sleuth/frontend/pages/onboarding-wizard/user/cli.vue?macro=true";
import { default as mcp4oMO7L_45AptBQkpSm0JDvrLpVTdrajOVFngSutor5E_45gMeta } from "/home/circleci/sleuth/frontend/pages/onboarding-wizard/user/mcp.vue?macro=true";
import { default as githubB6yzaykNZSd8MCbzEa_45f3sOGcbMItyCC2FQJUr3kTOgMeta } from "/home/circleci/sleuth/frontend/pages/onboarding-wizard/org/github.vue?macro=true";
import { default as skillszzCh5Fu2yhlViuGuTF_1yAwuAKqESpm4e5XJ7eOfmm4Meta } from "/home/circleci/sleuth/frontend/pages/onboarding-wizard/org/skills.vue?macro=true";
import { default as method7ihSIqWT9eUuTXXq45mlUHvwhUdiAx9G8mTkgdMHKoYMeta } from "/home/circleci/sleuth/frontend/pages/onboarding-wizard/user/method.vue?macro=true";
import { default as index_46generatedfI113vdnfC5ftUP0Yfn5ODIGwZp1I18fAGBOzSecY54Meta } from "/home/circleci/sleuth/frontend/pages/onboarding-wizard/index.generated.ts?macro=true";
import { default as familiarityb8ct81gQC4PlXp2H_45ElNz76neq73p9Gov9vQoe1suMkMeta } from "/home/circleci/sleuth/frontend/pages/onboarding-wizard/org/familiarity.vue?macro=true";
import { default as done_46generatedz6vHov9gI4zm1QrVFfnW_tgJ2dwSBz5i8Z51uc8t_45zsMeta } from "/home/circleci/sleuth/frontend/pages/onboarding-wizard/org/done.generated.ts?macro=true";
import { default as cli_46generatedP6SOUmN03NyJyAFxnSOgBaIXYz64HBx_45Zkj6lVt_45sgwMeta } from "/home/circleci/sleuth/frontend/pages/onboarding-wizard/user/cli.generated.ts?macro=true";
import { default as github_46generatedD6GHJDsgUlpidv5dDjbh8QzjQzeP32os9_45_xl6wjyzIMeta } from "/home/circleci/sleuth/frontend/pages/onboarding-wizard/org/github.generated.ts?macro=true";
import { default as onboarding_45wizard6m8U_45Y0CxS3phzStGI5FWaMXIjclymkVF2kO5ylziH0Meta } from "/home/circleci/sleuth/frontend/pages/onboarding-wizard.vue?macro=true";
import { default as settings_46generatedcI90a2EeRqAEpsFWjcFzC_45qgOQG5xHOA6lmArRTmTpYMeta } from "/home/circleci/sleuth/frontend/pages/settings.generated.ts?macro=true";
import { default as indexus4g35eZmVOoJ28fmxwohIJkv9T7ktxFruBjuBNSXCcMeta } from "/home/circleci/sleuth/frontend/pages/organization/index.vue?macro=true";
import { default as CreateBotModalLf_45WHvSVEaBW_Ci3AyCWoWaapPE1q_45xeEARFindQVigMeta } from "/home/circleci/sleuth/frontend/pages/bots/CreateBotModal.vue?macro=true";
import { default as index_46generatedETvg_llLpE2tf2h5YmR3446aedDCvX5rWn5pI1TaracMeta } from "/home/circleci/sleuth/frontend/pages/home/index.generated.ts?macro=true";
import { default as index0lzfM1AIdCqJ3UA_45M33vI23Ik_45EDC8FBZsyW5n2h_fUMeta } from "/home/circleci/sleuth/frontend/pages/reset-password/index.vue?macro=true";
import { default as index_46generatedBcLXuB4MNdr81vlApTwlb46nG7APBc_50KPbqobTy2QMeta } from "/home/circleci/sleuth/frontend/pages/roles/index.generated.ts?macro=true";
import { default as index_46generated4_45FbtyNHQ4KvIoxbFho9pXCLHyfKzyxzznnNo_sWJ3EMeta } from "/home/circleci/sleuth/frontend/pages/usage/index.generated.ts?macro=true";
import { default as _91gid_93_46generatedkk_WJCuVFGp4EySKzu2JGKyaETtN4g_r9mO_45c64R3FMMeta } from "/home/circleci/sleuth/frontend/pages/assets/[gid].generated.ts?macro=true";
import { default as index_46generatediWiHM1xwcTIDnzy8J3Jqiq4qNEDD_qKvkXQ8ZPhOvf0Meta } from "/home/circleci/sleuth/frontend/pages/assets/index.generated.ts?macro=true";
import { default as device_46generatedfFn5XRMfFSVY6oItmyrx60KsoDgJ0sWDbvl5qJMj4iEMeta } from "/home/circleci/sleuth/frontend/pages/oauth/device.generated.ts?macro=true";
import { default as aikd3fG8_45NqFHMqj3Vu1Zbxq8Qgv6I_45RTxg3fTP9B8yhcMeta } from "/home/circleci/sleuth/frontend/pages/settings/organization/ai.vue?macro=true";
import { default as indexvFAFq1MnIFbFGx24kPLY9HJlW8GmINJKxFMgORoFp1YMeta } from "/home/circleci/sleuth/frontend/pages/settings/organization/users/index.vue?macro=true";
import { default as indextwQzCpFISupx1UgeIaVuAj5r1N4K3ygXtmogJoPtpZMMeta } from "/home/circleci/sleuth/frontend/pages/settings/organization/users/[userId]/index.vue?macro=true";
import { default as externalkmKYlPDqU0dq6Flmsoo01jd9iFo7KlTbjQid9oxfwJIMeta } from "/home/circleci/sleuth/frontend/pages/settings/organization/users/[userId]/external.vue?macro=true";
import { default as index_46generatedQKA2sj6h6Uxz_45dh2v2WKq4OPbfdn3baXmYYZyNeyyu8Meta } from "/home/circleci/sleuth/frontend/pages/settings/organization/users/[userId]/index.generated.ts?macro=true";
import { default as external_46generatedt6gj4KPzEHBeeKkOZpQR5oImTYw_45MLuY_45H2USB4B0kcMeta } from "/home/circleci/sleuth/frontend/pages/settings/organization/users/[userId]/external.generated.ts?macro=true";
import { default as users4_45C3PeMMneZZICP8q_H_v5kGKf5BDx8IsyglfcxjW_cMeta } from "/home/circleci/sleuth/frontend/pages/settings/organization/users.vue?macro=true";
import { default as skills38aEdHgYg8fGXxnjOYlmmaANl0pDPucHNJ6RfJvp6foMeta } from "/home/circleci/sleuth/frontend/pages/settings/organization/skills.vue?macro=true";
import { default as general0T4YpCB_45gd_45Mppq6FvA4DrF2oj9BtuiT6r2o9VxYbzUMeta } from "/home/circleci/sleuth/frontend/pages/settings/organization/general.vue?macro=true";
import { default as indexCh_6hxsgJ3xBjthdLKe8Tnbbo_453FrRx5FSUWcIELA2oMeta } from "/home/circleci/sleuth/frontend/pages/settings/organization/integrations/index.vue?macro=true";
import { default as index_46generatedTqbsjhlJ_45BT5vA4ELqAyFvyoGVkbWowHmYskQcFIQtYMeta } from "/home/circleci/sleuth/frontend/pages/settings/organization/integrations/index.generated.ts?macro=true";
import { default as indexXIp8s03DCSn0etcIHjPQ43_uQO6fuBFxzI2jdTJEUb8Meta } from "/home/circleci/sleuth/frontend/pages/settings/organization/integrations/[providerId]/index.vue?macro=true";
import { default as index_46generated_45z6Zkx__45_45G1R9lECehxTR4HS6PqW4gdX5m8_dW0_45z2YMeta } from "/home/circleci/sleuth/frontend/pages/settings/organization/integrations/[providerId]/index.generated.ts?macro=true";
import { default as integrationsJ1SxEAUZgWK8v_lEz2a9O_450d6NxIaWHAYxlrwgGfo_454Meta } from "/home/circleci/sleuth/frontend/pages/settings/organization/integrations.vue?macro=true";
import { default as localization4YgxKhkVULetlURAWt5X9T5nmI5f6_45q04ZgF4LTO5b0Meta } from "/home/circleci/sleuth/frontend/pages/settings/organization/localization.vue?macro=true";
import { default as authenticationchdCMtmEdACrXPJkhREUT9KCBroGti00aTBHNGWybyYMeta } from "/home/circleci/sleuth/frontend/pages/settings/organization/authentication.vue?macro=true";
import { default as investment_45mixAqD_45eeUdB6xs9P0jIquOjEk8ubN8A0cz4ei5YWSbJsYMeta } from "/home/circleci/sleuth/frontend/pages/settings/organization/investment-mix.vue?macro=true";
import { default as organizationoZkLFStZpe96zgHl51Vs_45OPx_45VGarjH3l3U6VVSOttIMeta } from "/home/circleci/sleuth/frontend/pages/settings/organization.vue?macro=true";
import { default as _91botSlug_93_46generated8GL7rFTc_455GMGrczLV6HVtpF7408MnYY0qf_79rJFZ4Meta } from "/home/circleci/sleuth/frontend/pages/bots/[botSlug].generated.ts?macro=true";
import { default as indexnMMJ6dBiuyA2b3IrcWQPMsq8nyxl4RuoFGIDIFrVLo8Meta } from "/home/circleci/sleuth/frontend/pages/repositories/[gid]/index.vue?macro=true";
import { default as audit_45log_46generatedQciqjsU6SvTfUaLFwO3Xueuyc4Gjgx7tRsgqx_450d2J0Meta } from "/home/circleci/sleuth/frontend/pages/usage/audit-log.generated.ts?macro=true";
import { default as _91_91prUrl_93_93fuLWIHIRH5lz31_YNvvC4Sxj4lrWMVdcw0PNreFXYG8Meta } from "/home/circleci/sleuth/frontend/pages/change-requests/[[prUrl]].vue?macro=true";
import { default as installation_45requestshcoHU4LnxqtFs6h0_bEp6rXPCjfjqmc1SBV6ABeJaYIMeta } from "/home/circleci/sleuth/frontend/pages/usage/installation-requests.vue?macro=true";
import { default as CreateBotModal_46generated_og9FbpOwUXREwvV9sHktalIfa9yaYmJFE_45zu6FrP8cMeta } from "/home/circleci/sleuth/frontend/pages/bots/CreateBotModal.generated.ts?macro=true";
import { default as reset_45successe3VF464s6lrVsCpE9foZGgVEe6OiUgUJhfv4bDIbI0MMeta } from "/home/circleci/sleuth/frontend/pages/reset-password/reset-success.vue?macro=true";
import { default as _91_91prUrl_93_93ZQhinYtqA5onLZMlPOMSQLL3DA7x02Q5qwJ2nYk6RtkMeta } from "/home/circleci/sleuth/frontend/pages/skill-pull-requests/[[prUrl]].vue?macro=true";
import { default as indexP00hu7MdXyT8k_45fjiGfQ8U1Ggu0cbmA4uQTKL1i8ZYoMeta } from "/home/circleci/sleuth/frontend/pages/teamspace/[workspaceId]/index.vue?macro=true";
import { default as indexJWCnR1uvJRwoTLMhdZlq556JE1IuzgC48sxRw_j2AP8Meta } from "/home/circleci/sleuth/frontend/pages/users/[ownerGid]/assets/index.vue?macro=true";
import { default as request_45success9Y9pyV88WkAHR1IvTk_45LEB7a1mde_lRaW7W2i4tKd3sMeta } from "/home/circleci/sleuth/frontend/pages/reset-password/request-success.vue?macro=true";
import { default as generale51gQiwAcbxIwkgw0MJwTHlaSyzF_wL4uYaB1HsKsrkMeta } from "/home/circleci/sleuth/frontend/pages/settings/teamspace/[teamspaceId]/general.vue?macro=true";
import { default as investment_45mix2BkFeTxUX3_paHslfWz_uX_zTsEz9FsIc8wO6UD9h0sMeta } from "/home/circleci/sleuth/frontend/pages/settings/teamspace/[teamspaceId]/investment-mix.vue?macro=true";
import { default as general_46generated00_T0gccxbUTaTZAr9Jvk62WqJqmrUOSi4pvG8VdIOwMeta } from "/home/circleci/sleuth/frontend/pages/settings/teamspace/[teamspaceId]/general.generated.ts?macro=true";
import { default as teams_45and_45membersvJ6gs1zUIlhDnpjMA_SGWZ_bkbTz1wVg9XL00C_Md8QMeta } from "/home/circleci/sleuth/frontend/pages/settings/teamspace/[teamspaceId]/teams-and-members.vue?macro=true";
import { default as teams_45and_45members_46generatedy8Mfcv_jSNPtz07FqcFznEjjKNZUXHULFEvRdW1N0a8Meta } from "/home/circleci/sleuth/frontend/pages/settings/teamspace/[teamspaceId]/teams-and-members.generated.ts?macro=true";
import { default as _91teamspaceId_93PdHayYkssCBrZRZy81BLYkmKo0QXHHq5LfzUEz_cstcMeta } from "/home/circleci/sleuth/frontend/pages/settings/teamspace/[teamspaceId].vue?macro=true";
import { default as index_46generatedryoI4Mdju3acDFmbTvxvN_C91DDBBE1twZL3RV91_45RkMeta } from "/home/circleci/sleuth/frontend/pages/repositories/[gid]/index.generated.ts?macro=true";
import { default as set_45passwordZM1prtMaYFA9_2quNI9xNoOAbh4KsY9VcCz_fuVk8ZEMeta } from "/home/circleci/sleuth/frontend/pages/reset-password/[uid]/set-password.vue?macro=true";
import { default as installedCsXNNL58s9glTTqHUDDgHZULLI94GtHmMITPbfRk4DIMeta } from "/home/circleci/sleuth/frontend/pages/users/[ownerGid]/assets/installed.vue?macro=true";
import { default as _91_91prUrl_93_93_46generatednqiFBOegdxsE3S301P48qT6FWQsJMv5UWo1LrbSYhbEMeta } from "/home/circleci/sleuth/frontend/pages/change-requests/[[prUrl]].generated.ts?macro=true";
import { default as edit_45hUoGaezfC_OGdI8z9fU_4519DbXOjG2TrHdOOLqa_452YAMeta } from "/home/circleci/sleuth/frontend/pages/usage/dashboards/[dashboardId]/edit.vue?macro=true";
import { default as indexiFzGo08NRcBkybZNHk_eKh55vz8bnHZBRGOKpQbi678Meta } from "/home/circleci/sleuth/frontend/pages/usage/dashboards/[dashboardId]/index.vue?macro=true";
import { default as indexmLCoceiFK0VUKspPe_45iCFa37YoaFUtgZ93pNUDM2KDMMeta } from "/home/circleci/sleuth/frontend/pages/teamspace/[workspaceId]/reviews/index.vue?macro=true";
import { default as indexOC8aYFv7PHN3wcxZBlrDenRDWVKQC90EcZiihqZ3iUwMeta } from "/home/circleci/sleuth/frontend/pages/teamspace/[workspaceId]/surveys/index.vue?macro=true";
import { default as indexqJIZ92w1EJohDf8bVR9Jphnx_45XgGeI6UwYfXPET5b_45sMeta } from "/home/circleci/sleuth/frontend/pages/teamspace/[workspaceId]/dashboards/index.vue?macro=true";
import { default as indexlv94f0khsYy48n3MBLOXcXRffc0laVfDu77Q8NZJAAcMeta } from "/home/circleci/sleuth/frontend/pages/repositories/[gid]/suggested-skills/index.vue?macro=true";
import { default as _91teamspaceId_93_46generatedMOXwSrzKuvMwXCvK92CQ_4njT33V0EAITLPWymN9nmsMeta } from "/home/circleci/sleuth/frontend/pages/settings/teamspace/[teamspaceId].generated.ts?macro=true";
import { default as _91userCode_93iy8A_o4N1_45z8DnDOL6L4IXLINVN3Pn4HS5nRfI6rCq4Meta } from "/home/circleci/sleuth/frontend/pages/oauth/device-confirm/[clientId]/[userCode].vue?macro=true";
import { default as installed_46generatedqdPPv1qPXfJAYPafDAWkF3zoi78bXkwCEonbZEYBYzgMeta } from "/home/circleci/sleuth/frontend/pages/users/[ownerGid]/assets/installed.generated.ts?macro=true";
import { default as index_46generated8_d6fU1ccX2a4FsLGjOnSSEmsv7Vvy3_45QqDLVFHEEN8Meta } from "/home/circleci/sleuth/frontend/pages/usage/dashboards/[dashboardId]/index.generated.ts?macro=true";
import { default as _91userCode_93W__idC3Ny980ERVT_45kf3o2YjjaJm_x8tnhl3TUbNKv0Meta } from "/home/circleci/sleuth/frontend/pages/oauth/device-grant-status/[clientId]/[userCode].vue?macro=true";
import { default as indexcnJ1vOB492TR2rg4WoksFqP3Uy8l1uWf_45m0NKd7URJoMeta } from "/home/circleci/sleuth/frontend/pages/teamspace/[workspaceId]/reviews/[reviewId]/index.vue?macro=true";
import { default as indexFx_1No_XmPUonTOhnTPwFnmMEGoIWbhKN8s9DFSQwy0Meta } from "/home/circleci/sleuth/frontend/pages/teamspace/[workspaceId]/surveys/[surveyId]/index.vue?macro=true";
import { default as index_46generatedqpSNFQfleuJuD_45X_jm_45rXzr1Tqmr4ZuoQR2NHfp7wKIMeta } from "/home/circleci/sleuth/frontend/pages/repositories/[gid]/suggested-skills/index.generated.ts?macro=true";
import { default as edit8MnXguwQ0aw06xhUPwzLKECAKFAH2_45b_45qNE7AxKE16EMeta } from "/home/circleci/sleuth/frontend/pages/teamspace/[workspaceId]/dashboards/[dashboardId]/edit.vue?macro=true";
import { default as indexfetGZawPyl3dmCHrtmweOooBzSI3KKfVe92Kkzp6_nYMeta } from "/home/circleci/sleuth/frontend/pages/teamspace/[workspaceId]/dashboards/[dashboardId]/index.vue?macro=true";
import { default as device_45confirm_46generatedoTBSZMsN5h0iyJOzsJt5HtfPDNzVcJsj3MojLJ4u5wkMeta } from "/home/circleci/sleuth/frontend/pages/oauth/device-confirm/[clientId]/device-confirm.generated.ts?macro=true";
import { default as device_45grant_45status_46generatediZbtFHhCgTzfBCXpR_45GY_45rbWfQi3CfTjzQgsgtVcrpYMeta } from "/home/circleci/sleuth/frontend/pages/oauth/device-grant-status/[clientId]/device-grant-status.generated.ts?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexqnu_45AxWuCFAtIzfzfF5SPDSS2w5_45wgUaN4Ttr5_huYYMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: sign_45inRcFtNr8XsEZ7RHiDNTHDzFmQ3_45jzm_45dU8sd4Rjv_45xFEMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/sign-in.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: sign_45upmCeQhReUuBLYjSuVke2gz_45B49cDVdnRjoh3pRYvCfyYMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/sign-up.vue")
  },
  {
    name: "home",
    path: "/home",
    component: () => import("/home/circleci/sleuth/frontend/pages/home/index.vue")
  },
  {
    name: "roles",
    path: "/roles",
    component: () => import("/home/circleci/sleuth/frontend/pages/roles/index.vue")
  },
  {
    name: "usage",
    path: "/usage",
    meta: indexSXrQ7uimFmQg8za_P2eyc93iyh2HlbFKdCo5jqo0hOkMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/usage/index.vue")
  },
  {
    name: "assets-gid",
    path: "/assets/:gid()",
    component: () => import("/home/circleci/sleuth/frontend/pages/assets/[gid].vue")
  },
  {
    name: "assets",
    path: "/assets",
    component: () => import("/home/circleci/sleuth/frontend/pages/assets/index.vue")
  },
  {
    name: "oauth-device",
    path: "/oauth/device",
    meta: deviceXglsd_45yLRzveziYv_qa7hwevJuMp0BjB5S6HcbbXc5gMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/oauth/device.vue")
  },
  {
    name: "settings-user",
    path: "/settings/user",
    meta: userQDvU83MyYNp1yImAHSKfK6drtw0um2xaevjPIQnw9AoMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/user.vue"),
    children: [
  {
    name: "settings-user-tokens",
    path: "tokens",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/user/tokens.vue")
  },
  {
    name: "settings-user-general",
    path: "general",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/user/general.vue")
  },
  {
    name: "settings-user-my",
    path: "my",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/user/my/index.vue")
  },
  {
    name: "settings-user-my-external",
    path: "my/external",
    meta: externalhRqqKSQe6_45XO2LhltMb7L6wbcPcu85adK6KsvIM_TvEMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/user/my/external.vue")
  },
  {
    name: "settings-user-notification",
    path: "notification",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/user/notification.vue")
  },
  {
    name: "settings-user-tokens.generated",
    path: "tokens.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/user/tokens.generated.ts")
  },
  {
    name: "settings-user-my-index.generated",
    path: "my/index.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/user/my/index.generated.ts")
  },
  {
    name: "settings-user-notification.generated",
    path: "notification.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/user/notification.generated.ts")
  }
]
  },
  {
    name: "teamspace-new",
    path: "/teamspace/new",
    meta: newVSLyjEauHwssktRMpnhNmWVJKIRlEl0uWSUGbh62LlwMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/teamspace/new.vue"),
    children: [
  {
    name: "teamspace-new-name",
    path: "name",
    component: () => import("/home/circleci/sleuth/frontend/pages/teamspace/new/name.vue")
  },
  {
    name: "teamspace-new-name.generated",
    path: "name.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/teamspace/new/name.generated.ts")
  },
  {
    name: "teamspace-new-teams-and-members",
    path: "teams-and-members",
    component: () => import("/home/circleci/sleuth/frontend/pages/teamspace/new/teams-and-members.vue")
  }
]
  },
  {
    name: "bots-botSlug",
    path: "/bots/:botSlug()",
    component: () => import("/home/circleci/sleuth/frontend/pages/bots/[botSlug].vue")
  },
  {
    name: "delete-account",
    path: "/delete-account",
    component: () => import("/home/circleci/sleuth/frontend/pages/delete-account.vue")
  },
  {
    name: "index.generated",
    path: "/index.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/index.generated.ts")
  },
  {
    name: _91teamId_93CwfZxYJ45N7a9FbTCFmlcgpeSV9Th2pmbXCvlmnCbL0Meta?.name,
    path: "/teams/:teamId()",
    component: () => import("/home/circleci/sleuth/frontend/pages/teams/[teamId].vue"),
    children: [
  {
    name: "teams-teamId",
    path: "",
    component: () => import("/home/circleci/sleuth/frontend/pages/teams/[teamId]/index.vue")
  },
  {
    name: "teams-teamId-index.generated",
    path: "index.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/teams/[teamId]/index.generated.ts")
  }
]
  },
  {
    name: "usage-audit-log",
    path: "/usage/audit-log",
    meta: audit_45logVt8A3fgSlcz6ejzkpN8JViG5ESWln2rIlz7d2EapQv0Meta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/usage/audit-log.vue")
  },
  {
    name: onboarding_45wizard6m8U_45Y0CxS3phzStGI5FWaMXIjclymkVF2kO5ylziH0Meta?.name,
    path: "/onboarding-wizard",
    meta: onboarding_45wizard6m8U_45Y0CxS3phzStGI5FWaMXIjclymkVF2kO5ylziH0Meta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/onboarding-wizard.vue"),
    children: [
  {
    name: "onboarding-wizard",
    path: "",
    component: () => import("/home/circleci/sleuth/frontend/pages/onboarding-wizard/index.vue")
  },
  {
    name: "onboarding-wizard-org-done",
    path: "org/done",
    meta: {"middleware":"onboarding-org-admin"},
    component: () => import("/home/circleci/sleuth/frontend/pages/onboarding-wizard/org/done.vue")
  },
  {
    name: "onboarding-wizard-user-cli",
    path: "user/cli",
    component: () => import("/home/circleci/sleuth/frontend/pages/onboarding-wizard/user/cli.vue")
  },
  {
    name: "onboarding-wizard-user-mcp",
    path: "user/mcp",
    component: () => import("/home/circleci/sleuth/frontend/pages/onboarding-wizard/user/mcp.vue")
  },
  {
    name: "onboarding-wizard-org-github",
    path: "org/github",
    meta: {"middleware":"onboarding-org-admin"},
    component: () => import("/home/circleci/sleuth/frontend/pages/onboarding-wizard/org/github.vue")
  },
  {
    name: "onboarding-wizard-org-skills",
    path: "org/skills",
    meta: {"middleware":"onboarding-org-admin"},
    component: () => import("/home/circleci/sleuth/frontend/pages/onboarding-wizard/org/skills.vue")
  },
  {
    name: "onboarding-wizard-user-method",
    path: "user/method",
    component: () => import("/home/circleci/sleuth/frontend/pages/onboarding-wizard/user/method.vue")
  },
  {
    name: "onboarding-wizard-index.generated",
    path: "index.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/onboarding-wizard/index.generated.ts")
  },
  {
    name: "onboarding-wizard-org-familiarity",
    path: "org/familiarity",
    meta: {"middleware":"onboarding-org-admin"},
    component: () => import("/home/circleci/sleuth/frontend/pages/onboarding-wizard/org/familiarity.vue")
  },
  {
    name: "onboarding-wizard-org-done.generated",
    path: "org/done.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/onboarding-wizard/org/done.generated.ts")
  },
  {
    name: "onboarding-wizard-user-cli.generated",
    path: "user/cli.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/onboarding-wizard/user/cli.generated.ts")
  },
  {
    name: "onboarding-wizard-org-github.generated",
    path: "org/github.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/onboarding-wizard/org/github.generated.ts")
  }
]
  },
  {
    name: "settings.generated",
    path: "/settings.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings.generated.ts")
  },
  {
    name: "organization",
    path: "/organization",
    component: () => import("/home/circleci/sleuth/frontend/pages/organization/index.vue")
  },
  {
    name: "bots-CreateBotModal",
    path: "/bots/CreateBotModal",
    component: () => import("/home/circleci/sleuth/frontend/pages/bots/CreateBotModal.vue")
  },
  {
    name: "home-index.generated",
    path: "/home/index.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/home/index.generated.ts")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: index0lzfM1AIdCqJ3UA_45M33vI23Ik_45EDC8FBZsyW5n2h_fUMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/reset-password/index.vue")
  },
  {
    name: "roles-index.generated",
    path: "/roles/index.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/roles/index.generated.ts")
  },
  {
    name: "usage-index.generated",
    path: "/usage/index.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/usage/index.generated.ts")
  },
  {
    name: "assets-gid.generated",
    path: "/assets/:gid().generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/assets/[gid].generated.ts")
  },
  {
    name: "assets-index.generated",
    path: "/assets/index.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/assets/index.generated.ts")
  },
  {
    name: "oauth-device.generated",
    path: "/oauth/device.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/oauth/device.generated.ts")
  },
  {
    name: "settings-organization",
    path: "/settings/organization",
    meta: organizationoZkLFStZpe96zgHl51Vs_45OPx_45VGarjH3l3U6VVSOttIMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/organization.vue"),
    children: [
  {
    name: "settings-organization-ai",
    path: "ai",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/organization/ai.vue")
  },
  {
    name: users4_45C3PeMMneZZICP8q_H_v5kGKf5BDx8IsyglfcxjW_cMeta?.name,
    path: "users",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/organization/users.vue"),
    children: [
  {
    name: "settings-organization-users",
    path: "",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/organization/users/index.vue")
  },
  {
    name: "settings-organization-users-userId",
    path: ":userId()",
    meta: indextwQzCpFISupx1UgeIaVuAj5r1N4K3ygXtmogJoPtpZMMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/organization/users/[userId]/index.vue")
  },
  {
    name: "settings-organization-users-userId-external",
    path: ":userId()/external",
    meta: externalkmKYlPDqU0dq6Flmsoo01jd9iFo7KlTbjQid9oxfwJIMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/organization/users/[userId]/external.vue")
  },
  {
    name: "settings-organization-users-userId-index.generated",
    path: ":userId()/index.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/organization/users/[userId]/index.generated.ts")
  },
  {
    name: "settings-organization-users-userId-external.generated",
    path: ":userId()/external.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/organization/users/[userId]/external.generated.ts")
  }
]
  },
  {
    name: "settings-organization-skills",
    path: "skills",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/organization/skills.vue")
  },
  {
    name: "settings-organization-general",
    path: "general",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/organization/general.vue")
  },
  {
    name: integrationsJ1SxEAUZgWK8v_lEz2a9O_450d6NxIaWHAYxlrwgGfo_454Meta?.name,
    path: "integrations",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/organization/integrations.vue"),
    children: [
  {
    name: "settings-organization-integrations",
    path: "",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/organization/integrations/index.vue")
  },
  {
    name: "settings-organization-integrations-index.generated",
    path: "index.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/organization/integrations/index.generated.ts")
  },
  {
    name: "settings-organization-integrations-providerId",
    path: ":providerId()",
    meta: indexXIp8s03DCSn0etcIHjPQ43_uQO6fuBFxzI2jdTJEUb8Meta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/organization/integrations/[providerId]/index.vue")
  },
  {
    name: "settings-organization-integrations-providerId-index.generated",
    path: ":providerId()/index.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/organization/integrations/[providerId]/index.generated.ts")
  }
]
  },
  {
    name: "settings-organization-localization",
    path: "localization",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/organization/localization.vue")
  },
  {
    name: "settings-organization-authentication",
    path: "authentication",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/organization/authentication.vue")
  },
  {
    name: "settings-organization-investment-mix",
    path: "investment-mix",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/organization/investment-mix.vue")
  }
]
  },
  {
    name: "bots-botSlug.generated",
    path: "/bots/:botSlug().generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/bots/[botSlug].generated.ts")
  },
  {
    name: "repositories-gid",
    path: "/repositories/:gid()",
    component: () => import("/home/circleci/sleuth/frontend/pages/repositories/[gid]/index.vue")
  },
  {
    name: "usage-audit-log.generated",
    path: "/usage/audit-log.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/usage/audit-log.generated.ts")
  },
  {
    name: "change-requests-prUrl",
    path: "/change-requests/:prUrl?",
    component: () => import("/home/circleci/sleuth/frontend/pages/change-requests/[[prUrl]].vue")
  },
  {
    name: "usage-installation-requests",
    path: "/usage/installation-requests",
    meta: installation_45requestshcoHU4LnxqtFs6h0_bEp6rXPCjfjqmc1SBV6ABeJaYIMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/usage/installation-requests.vue")
  },
  {
    name: "bots-CreateBotModal.generated",
    path: "/bots/CreateBotModal.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/bots/CreateBotModal.generated.ts")
  },
  {
    name: "reset-password-reset-success",
    path: "/reset-password/reset-success",
    meta: reset_45successe3VF464s6lrVsCpE9foZGgVEe6OiUgUJhfv4bDIbI0MMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/reset-password/reset-success.vue")
  },
  {
    name: "skill-pull-requests-prUrl",
    path: "/skill-pull-requests/:prUrl?",
    meta: _91_91prUrl_93_93ZQhinYtqA5onLZMlPOMSQLL3DA7x02Q5qwJ2nYk6RtkMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/skill-pull-requests/[[prUrl]].vue")
  },
  {
    name: "teamspace-workspaceId",
    path: "/teamspace/:workspaceId()",
    component: () => import("/home/circleci/sleuth/frontend/pages/teamspace/[workspaceId]/index.vue")
  },
  {
    name: "users-ownerGid-assets",
    path: "/users/:ownerGid()/assets",
    component: () => import("/home/circleci/sleuth/frontend/pages/users/[ownerGid]/assets/index.vue")
  },
  {
    name: "reset-password-request-success",
    path: "/reset-password/request-success",
    meta: request_45success9Y9pyV88WkAHR1IvTk_45LEB7a1mde_lRaW7W2i4tKd3sMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/reset-password/request-success.vue")
  },
  {
    name: "settings-teamspace-teamspaceId",
    path: "/settings/teamspace/:teamspaceId()",
    meta: _91teamspaceId_93PdHayYkssCBrZRZy81BLYkmKo0QXHHq5LfzUEz_cstcMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/teamspace/[teamspaceId].vue"),
    children: [
  {
    name: "settings-teamspace-teamspaceId-general",
    path: "general",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/teamspace/[teamspaceId]/general.vue")
  },
  {
    name: "settings-teamspace-teamspaceId-investment-mix",
    path: "investment-mix",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/teamspace/[teamspaceId]/investment-mix.vue")
  },
  {
    name: "settings-teamspace-teamspaceId-general.generated",
    path: "general.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/teamspace/[teamspaceId]/general.generated.ts")
  },
  {
    name: "settings-teamspace-teamspaceId-teams-and-members",
    path: "teams-and-members",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/teamspace/[teamspaceId]/teams-and-members.vue")
  },
  {
    name: "settings-teamspace-teamspaceId-teams-and-members.generated",
    path: "teams-and-members.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/teamspace/[teamspaceId]/teams-and-members.generated.ts")
  }
]
  },
  {
    name: "repositories-gid-index.generated",
    path: "/repositories/:gid()/index.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/repositories/[gid]/index.generated.ts")
  },
  {
    name: "reset-password-uid-set-password",
    path: "/reset-password/:uid()/set-password",
    meta: set_45passwordZM1prtMaYFA9_2quNI9xNoOAbh4KsY9VcCz_fuVk8ZEMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/reset-password/[uid]/set-password.vue")
  },
  {
    name: "users-ownerGid-assets-installed",
    path: "/users/:ownerGid()/assets/installed",
    component: () => import("/home/circleci/sleuth/frontend/pages/users/[ownerGid]/assets/installed.vue")
  },
  {
    name: "change-requests-prUrl.generated",
    path: "/change-requests/:prUrl?.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/change-requests/[[prUrl]].generated.ts")
  },
  {
    name: "usage-dashboards-dashboardId-edit",
    path: "/usage/dashboards/:dashboardId()/edit",
    meta: edit_45hUoGaezfC_OGdI8z9fU_4519DbXOjG2TrHdOOLqa_452YAMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/usage/dashboards/[dashboardId]/edit.vue")
  },
  {
    name: "usage-dashboards-dashboardId",
    path: "/usage/dashboards/:dashboardId()",
    meta: indexiFzGo08NRcBkybZNHk_eKh55vz8bnHZBRGOKpQbi678Meta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/usage/dashboards/[dashboardId]/index.vue")
  },
  {
    name: "teamspace-workspaceId-reviews",
    path: "/teamspace/:workspaceId()/reviews",
    component: () => import("/home/circleci/sleuth/frontend/pages/teamspace/[workspaceId]/reviews/index.vue")
  },
  {
    name: "teamspace-workspaceId-surveys",
    path: "/teamspace/:workspaceId()/surveys",
    component: () => import("/home/circleci/sleuth/frontend/pages/teamspace/[workspaceId]/surveys/index.vue")
  },
  {
    name: "teamspace-workspaceId-dashboards",
    path: "/teamspace/:workspaceId()/dashboards",
    component: () => import("/home/circleci/sleuth/frontend/pages/teamspace/[workspaceId]/dashboards/index.vue")
  },
  {
    name: "repositories-gid-suggested-skills",
    path: "/repositories/:gid()/suggested-skills",
    component: () => import("/home/circleci/sleuth/frontend/pages/repositories/[gid]/suggested-skills/index.vue")
  },
  {
    name: "settings-teamspace-teamspaceId.generated",
    path: "/settings/teamspace/:teamspaceId().generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/settings/teamspace/[teamspaceId].generated.ts")
  },
  {
    name: "oauth-device-confirm-clientId-userCode",
    path: "/oauth/device-confirm/:clientId()/:userCode()",
    meta: _91userCode_93iy8A_o4N1_45z8DnDOL6L4IXLINVN3Pn4HS5nRfI6rCq4Meta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/oauth/device-confirm/[clientId]/[userCode].vue")
  },
  {
    name: "users-ownerGid-assets-installed.generated",
    path: "/users/:ownerGid()/assets/installed.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/users/[ownerGid]/assets/installed.generated.ts")
  },
  {
    name: "usage-dashboards-dashboardId-index.generated",
    path: "/usage/dashboards/:dashboardId()/index.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/usage/dashboards/[dashboardId]/index.generated.ts")
  },
  {
    name: "oauth-device-grant-status-clientId-userCode",
    path: "/oauth/device-grant-status/:clientId()/:userCode()",
    meta: _91userCode_93W__idC3Ny980ERVT_45kf3o2YjjaJm_x8tnhl3TUbNKv0Meta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/oauth/device-grant-status/[clientId]/[userCode].vue")
  },
  {
    name: "teamspace-workspaceId-reviews-reviewId",
    path: "/teamspace/:workspaceId()/reviews/:reviewId()",
    meta: indexcnJ1vOB492TR2rg4WoksFqP3Uy8l1uWf_45m0NKd7URJoMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/teamspace/[workspaceId]/reviews/[reviewId]/index.vue")
  },
  {
    name: "teamspace-workspaceId-surveys-surveyId",
    path: "/teamspace/:workspaceId()/surveys/:surveyId()",
    meta: indexFx_1No_XmPUonTOhnTPwFnmMEGoIWbhKN8s9DFSQwy0Meta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/teamspace/[workspaceId]/surveys/[surveyId]/index.vue")
  },
  {
    name: "repositories-gid-suggested-skills-index.generated",
    path: "/repositories/:gid()/suggested-skills/index.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/repositories/[gid]/suggested-skills/index.generated.ts")
  },
  {
    name: "teamspace-workspaceId-dashboards-dashboardId-edit",
    path: "/teamspace/:workspaceId()/dashboards/:dashboardId()/edit",
    meta: edit8MnXguwQ0aw06xhUPwzLKECAKFAH2_45b_45qNE7AxKE16EMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/teamspace/[workspaceId]/dashboards/[dashboardId]/edit.vue")
  },
  {
    name: "teamspace-workspaceId-dashboards-dashboardId",
    path: "/teamspace/:workspaceId()/dashboards/:dashboardId()",
    meta: indexfetGZawPyl3dmCHrtmweOooBzSI3KKfVe92Kkzp6_nYMeta || {},
    component: () => import("/home/circleci/sleuth/frontend/pages/teamspace/[workspaceId]/dashboards/[dashboardId]/index.vue")
  },
  {
    name: "oauth-device-confirm-clientId-device-confirm.generated",
    path: "/oauth/device-confirm/:clientId()/device-confirm.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/oauth/device-confirm/[clientId]/device-confirm.generated.ts")
  },
  {
    name: "oauth-device-grant-status-clientId-device-grant-status.generated",
    path: "/oauth/device-grant-status/:clientId()/device-grant-status.generated",
    component: () => import("/home/circleci/sleuth/frontend/pages/oauth/device-grant-status/[clientId]/device-grant-status.generated.ts")
  }
]